import bms from "./bms";
import cms from "./cms";
import ems from "./ems";
import fms from "./fms";
import sms from "./sms";
import ums from "./ums";
import zms from "./zms";

export default {
  // 华博特项目接口文档
  bms,
  // 华博特项目接口文档
  cms,
  // 华博特项目接口文档
  ems,
  // 华博特项目接口文档
  fms,
  // 华博特项目接口文档
  sms,
  // 华博特项目接口文档
  ums,
  // 华博特项目接口文档
  zms,
};
